<template>
  <div>
    <!-- @selection-change="handleSelectionChange" -->
    <common-dialog
      ref="dialog"
      width="900px"
      show-save-button
      unit="发货通知单"
      edit-title
      id-key="DeliveryDocId"
      :data="data"
      :line-form="true"
      :get-data-func="api.info"
      :form-rules="rules"
      @create-opened="onCreateOpened"
      :save-func="() => {}"
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <div class="row-head">基本信息</div>
        <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="订单编号">
                <span class="detail-span">{{ data.OrderNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="通知单号">
                <span class="detail-span">{{ data.DeliveryDocNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="客户名称">
                <span class="detail-span">{{ data.FullName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="提交人">
                <span class="detail-span">{{ data.EmpName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="提交时间">
                <span class="detail-span">{{
                  $commonJs.toDateString(data.DeliveryDate)
                }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="发货方式">
                <!-- 0：送货/1：物流/2：快递/3：自提 -->
                <el-select v-model="data.DeliveryWay">
                  <el-option :value="0" label="送货"></el-option>
                  <el-option :value="1" label="物流"></el-option>
                  <el-option :value="2" label="快递"></el-option>
                  <el-option :value="3" label="自提"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row>
            <el-col :span="24">
              <el-form-item label="交货地址">
                <span class="detail-span">
                  <span>{{data.Person}}</span>
                  <span v-if="data.Phone&&!isMB">/{{data.Phone}}</span>
                  <span v-if="data.Address">/{{data.Address}}</span>
                </span>
              </el-form-item>
            </el-col>
          </el-row> -->
          <!-- <el-row :gutter="15">
            <el-col :span="isMB?24:12">
              <el-form-item label="发货日期">
                <div style="display: flex;">
                  <el-date-picker
                    type="date"
                    v-model="data.DeliveryDate"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    :editable="false"
                    :clearable="false"
                  ></el-date-picker>
                  <el-select v-model="data.AmPm" v-if="!isMB">
                    <el-option label="上午" value="上午"></el-option>
                    <el-option label="下午" value="下午"></el-option>
                  </el-select>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="isMB">
              <el-form-item label="发货时间">
                <el-select v-model="data.AmPm">
                  <el-option label="上午" value="上午"></el-option>
                  <el-option label="下午" value="下午"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="经办人" prop="EmpId">
                <select-input
                  placeholder="选择经办人"
                  :label="data.EmpName"
                  v-model="data.EmpId"
                  @click="openEmployee('emp')"
                />
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-row>
        <el-divider>货品信息</el-divider>
        <el-table class="table-line tb-c-head" :data="data.Products" border>
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column
            label="产品编号"
            align="center"
            prop="ProductNo"
            min-width="150"
          />
          <el-table-column
            label="产品名称"
            align="center"
            prop="ProductName"
            min-width="150"
          />
          <el-table-column
            label="规格型号"
            align="center"
            prop="ProductSpec"
            min-width="90"
          />
          <el-table-column
            label="模号"
            align="center"
            prop="MouldNo"
            min-width="90"
          />
          <el-table-column
            label="订单数量"
            prop="SaQuantity"
            min-width="120"
            align="center"
          />
          <el-table-column
            label="已生产数量"
            prop="ProductionQuantity"
            min-width="120"
            align="center"
          />
          <el-table-column
            label="可发货数量"
            prop="InventoryQuantity"
            min-width="120"
            align="center"
          />
          <el-table-column label="发货数量" min-width="120" align="center">
            <template slot-scope="{ row }">
              <el-input
                @input="onInput(row, 'Quantity')"
                v-model.number="row.Quantity"
              ></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="60px"
            
          >
            <template slot-scope="{ row, $index }">
              <el-button type="text" @click="del(row, $index)">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </template>
      <!-- <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
      <product-dialog ref="productDialog" in-dialog selectable @select="setProduct" /> -->
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
// import empDialog from "@/components/personnel/result/record/listDialog";
// import productDialog from "@/components/sale/order/productDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    // empDialog,
    // productDialog,
  },
  data() {
    return {
      api: require("@/api/sa/deliveryDoc").default,
      code_api: require("@/api/sy/serialCode").default,
      order_api: require("@/api/sa/saOrder").default,
      data: {
        Products: [],
        DeliveryDocId: 0,
        DeliveryDocNo: "",
        OrderId: 0,
        DeliveryDate: "",
        EmpId: 0,
        Remark: "",
        Status: 0,
        OrderNo: "",
        TradeUnitNo: "",
        ShortName: "",
        FullName: "",
        DeliveryWay: 0,
        EmpName:"",
      },
      current: null,
      DelProducts: [],
      Mode: 0,
      isMB: this.$store.state.isMB,
      rules: {
        DeliveryDocNo: [{ required: true, message: "通知单号不能为空" }],
        EmpId: [{ required: true, message: "请选择经办人" }],
      },
    };
  },

  computed: {},
  methods: {
    onCreateOpened(data) {
      console.log("创建", this.$commonJs.toJson(data));
      var params = { OrderId: data.OrderId, ToDelivery: true };
      
      const user = this.$store.state.user;
      if (user) {
        this.data.EmpId = user.empId;
        this.data.EmpName = user.name;
      }
      this.order_api.info(data.OrderId).then(res=>{
        if(res.Code === 0){
          // this.data = res.Data;
            this.data.DeliveryDocId = res.Data.DeliveryDocId
            this.data.OrderId = res.Data.OrderId
            this.data.DeliveryDate = this.$commonJs.getToday()
          
            this.data.Remark = res.Data.Remark
            this.data.Status = res.Data.Status
            this.data.AddTime = res.Data.AddTime
            this.data.OrderNo = res.Data.OrderNo
            this.data.TradeUnitNo = res.Data.TradeUnitNo
            this.data.ShortName = res.Data.ShortName
            this.data.FullName = res.Data.FullName
            this.data.DeliveryWay = res.Data.DeliveryWay
            //   this.data.EmpId = res.Data.EmpId
            // this.data.EmpName = res.Data.EmpName;
            this.data.Products = res.Data.Products;
        }
      })
      // this.getDetails(params);

      this.code_api.previewNo("发货通知单").then((res) => {
        console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DeliveryDocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取发货通知单编号失败");
        }
      });
    },
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },
    // getDetails(params) {
    //   this.product_api.list(params).then((res) => {
    //     if (res.Code == 0) {
    //       this.data.Products = res.Data.map((x) => {
    //         return {
    //           DeliveryDocProductId: 0,
    //           DeliveryDocId: this.data.DeliveryDocId,
    //           DeliveryDocNo: this.data.DeliveryDocNo,
    //           OrderProductId: x.OrderProductId,
    //           OrderId: x.OrderId,
    //           ProductId: x.ProductId,
    //           ProductNo: x.ProductNo,
    //           ProductName: x.ProductName,
    //           ProductSpec: x.ProductSpec,
    //           ProductUnit: x.ProductUnit,
    //           ToDeliveryQuantity: x.ToDeliveryQuantity, //可发货量
    //           Quantity: x.ToDeliveryQuantity, //本次发货数量
    //           T: 0,
    //         };
    //       });
    //     } else {
    //       this.$message.error(res.Msg);
    //     }
    //   });
    // },
    // openEmployee() {
    //   this.$refs.empDialog.open().then((that) => {
    //     that.getData();
    //   });
    // },
    // setEmp(data) {
    //   this.data.EmpId = data.EmpId;
    //   this.data.EmpName = data.EmpName;
    // },
    // openProduct(row) {
    //   this.current = row;
    //   this.$refs.productDialog.open().then((that) => {
    //     that.getData({ OrderId: this.data.OrderId });
    //   });
    // },
    // setProduct(data) {
    //   console.log("product", data);
    //   this.current.OrderProductId = data.OrderProductId;
    //   this.current.OrderId = data.OrderId;
    //   this.current.ProductId = data.ProductId;
    //   this.current.ProductNo = data.ProductNo; //产品编号
    //   this.current.ProductName = data.ProductName; //产品名称
    //   this.current.ProductSpec = data.ProductSpec; //产品规格
    //   this.current.ProductUnit = data.ProductUnit; //产品单位
    //   this.current.ToDeliveryQuantity = data.ToDeliveryQuantity; //ToDeliveryQuantity
    //   this.current.T = this.current.T == 0 ? 0 : 1;
    // },
    // add() {
    //   this.data.Products.push({
    //     DeliveryDocProductId: 0,
    //     DeliveryDocId: this.data.DeliveryDocId,
    //     DeliveryDocNo: this.data.DeliveryDocNo,
    //     OrderProductId: null,
    //     OrderId: null,
    //     ProductId: null,
    //     ProductNo: "",
    //     ProductName: "",
    //     ProductSpec: "",
    //     ProductUnit: "",
    //     ToDeliveryQuantity: null, //可发货量
    //     Quantity: null, //本次发货数量
    //     T: 0,
    //   });
    // },
    del(row, index) {
      if (row != 0) this.DelProducts.push({ ...row, T: 2 });
      this.data.Products.splice(index, 1);
    },
    onInput(row, type) {
      row.T = row.T == 0 ? 0 : 1;
      if (row[type]) row[type] = this.$commonJs.obj.toNumber(row[type]);
      //本次发货数量为空时，设为0
      if (!row[type]) row[type] = 0;
      //本次发货数量不能大于可发货数量
      if (row.Quantity > row.ToDeliveryQuantity)
        row.Quantity = row.ToDeliveryQuantity;
    },
    onBeforeSave() {
      var Quantity = this.data.Products.some((x) => x.Quantity <= 0);
      if (Quantity) {
        this.$message.warning("到货信息 - 本次发货数量需大于0");
        return false;
      }

      var data = { ...this.data };
      data.Products = data.Products.filter((x) => x.T != null);
      this.DelProducts.forEach((x) => {
        data.Products.push(x);
      });

      data.Products.forEach(item => {
        if(item.DeliveryDocProductId && item.DeliveryDocProductId !== 0){
          item.T = 1
        }
      })
      console.log("onBeforeSave", JSON.parse(JSON.stringify(data)));
      this.$refs.dialog.isLoading = true;
      this.api.save(data).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      this.data.Products = [];
    },
  },
};
</script>
